import './popup-manager';
import './ajax-manager';
import './menu';
import './legacy';
//import './tinymce';

import '../scss/styles.scss';